export const composeExpostProject = (interventionZoneId, inventories, interventions) => {

  const transformedInterventions = interventions.map(({ co2InterventionType, ...rest }) => ({
    ...rest,
    type: co2InterventionType,
  }));

  const groupedInterventions =
  Object.groupBy?.(transformedInterventions, (item) => item.type) ||
  Object.fromEntries(
    transformedInterventions
      .map((item) => item.type)
      .filter((v, i, a) => a.indexOf(v) === i)
      .map((key) => [key, transformedInterventions.filter((item) => item.type === key)])
  );

  const finalResult = Object.fromEntries(
    Object.entries(groupedInterventions).map(([key, value]) => [
      key,
      // eslint-disable-next-line no-unused-vars
      value.map(({ type, ...rest }) => rest),
    ])
  );

  return {
    intervention_zone_id: interventionZoneId,
    inventories,
    ...finalResult
  };
};